module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "visible": _vm.isShowImageDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.isShowImageDialog = $event
      },
      "closed": _vm.clearImg
    }
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%",
      "display": "block",
      "margin": "0 auto"
    },
    attrs: {
      "src": _vm.imgs
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-37f394f8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/imgPreview/ImgPreview.vue
// module id = 1185
// module chunks = 1